module.exports = __webpack_public_path__ + "static/317939799_666027215193717_513834572527467737_n.jpg-1671186393237-8d4200f02feaec8164b26bb9fb8bc0a2.webp";